/*
 *
 *  actions
 *
 */

import {
 
  LOAD_OG_PHOTOS,
  LOAD_OG_PHOTOS_SUCCESS,
  LOAD_OG_PHOTOS_ERROR,


  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,


  ADD_TEAM_ASSIGN, 
  ADD_TEAM_ASSIGN_SUCCESS,
  ADD_TEAM_ASSIGN_ERROR,

  ADD_PRODUCT_ASSIGN,
  ADD_PRODUCT_ASSIGN_SUCCESS,
  ADD_PRODUCT_ASSIGN_ERROR,

  ADD_MULTIPLE_PRODUCT_ASSIGN,
  ADD_MULTIPLE_PRODUCT_ASSIGN_SUCCESS,
  ADD_MULTIPLE_PRODUCT_ASSIGN_ERROR,

  ADD_MULTIPLE_TEAM_ASSIGN,
  ADD_MULTIPLE_TEAM_ASSIGN_SUCCESS,
  ADD_MULTIPLE_TEAM_ASSIGN_ERROR,

 
} from "./constants"

export function loadRecordsCacheHit() {
  return {
   // type: LOAD_RECORDS_VALID_CACHE,
  }
}


export function loadOgPhotos(searchFilter) {
  return {
    type: LOAD_OG_PHOTOS,
    searchFilter,
  }
}


export function loadOgPhotosSuccess(ogPhotos_details, success) {
  return {
    type: LOAD_OG_PHOTOS_SUCCESS,
    ogPhotos_details,
    success,
  }
}


export function loadOgPhotosError(error) {
  return {
    type: LOAD_OG_PHOTOS_ERROR,
    error,
  }
}



export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

export function addTeamAssign(team_details) {
  return {
    type: ADD_TEAM_ASSIGN,
    team_details,
  }
}

export function addTeamAssignSuccess(team_details) {
  return {
    type: ADD_TEAM_ASSIGN_SUCCESS,
    team_details
    
  }
}


export function addTeamAssignError(error) {
  return {
    type: ADD_TEAM_ASSIGN_ERROR,
    error,
  }
}

export function addProductAssign(product_details) {
  return {
    type: ADD_PRODUCT_ASSIGN,
    product_details,
  }
}

export function addProductAssignSuccess(product_details) {
  return {
    type: ADD_PRODUCT_ASSIGN_SUCCESS,
    product_details
    
  }
}


export function addProductAssignError(error) {
  return {
    type: ADD_PRODUCT_ASSIGN_ERROR,
    error,
  }
}


export function addMultipleProductAssign(productDetails) {
  return {
    type: ADD_MULTIPLE_PRODUCT_ASSIGN,
    productDetails,
  }
}

export function  addMultipleProductAssignSuccess() {
  return {
    type: ADD_MULTIPLE_PRODUCT_ASSIGN_SUCCESS,
    
    
  }
}


export function  addMultipleProductAssignError(error) {
  return {
    type: ADD_MULTIPLE_PRODUCT_ASSIGN_ERROR,
    error,
  }
}
export function addMultipleTeamAssign(teamDetails) {
  return {
    type: ADD_MULTIPLE_TEAM_ASSIGN,
    teamDetails,
  }
}

export function  addMultipleTeamAssignSuccess() {
  return {
    type: ADD_MULTIPLE_TEAM_ASSIGN_SUCCESS,
    
    
  }
}

export function  addMultipleTeamAssignError(error) {
  return {
    type: ADD_MULTIPLE_TEAM_ASSIGN_ERROR,
    error,
  }
}
const actions = {
 loadOgPhotos,
 loadOgPhotosSuccess,
 loadOgPhotosError,

  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  addTeamAssign,
  addTeamAssignSuccess,
  addTeamAssignError,

  addProductAssign,
  addProductAssignSuccess,
  addProductAssignError,

  addMultipleProductAssign,
  addMultipleProductAssignSuccess,
  addMultipleProductAssignError,
  
  addMultipleTeamAssign,
  addMultipleTeamAssignSuccess,
  addMultipleTeamAssignError


}

export default actions
